import { useState, useEffect } from "react";
import { Filter } from "react-feather";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";  
import AdminTopbar from "../../component/AdminTopbar";
import { useParams } from "react-router-dom";
import EditProjectDetails from "../../component/EditProjectDetails";
import AddTask from "../../component/AddTask";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddFiles from "../../component/AddFiles";



const ProjectDetails = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState({
    description: false,
    priority: false,
    plannedDate: false,
    completionDate: false,
    actualCompletionDate: false,
  });

  const [tempData, setTempData] = useState({
    description: "",
    priority: "",
    plannedDate: "",
    completionDate: "",
    actualCompletionDate: "",
  });

  useEffect(() => {
    const fetchProjectData = async () => {
      try {
        const response = await axios.get(`${baseurl}getProjectManagementById/${id}`);

        if (response.data && response.data.project) {
          setFormData(response.data.project);
          setTempData({
            description: response.data.project.description,
            priority: response.data.project.priority,
            plannedDate: response.data.project.planned_date,
            completionDate: response.data.project.completion_date,
            actualCompletionDate: response.data.project.actual_completion_date,
          });
          setLoading(false);
        } else {
          throw new Error("No project data found");
        }
      } catch (err) {
        console.error("Error fetching project data:", err);
        setError('Failed to load project data');
        setLoading(false);
      }
    };

    fetchProjectData();
  }, [id]);

  const handleEditClick = (field) => {
    setIsEditing((prevState) => ({ ...prevState, [field]: true }));
  };

  const handleChange = (e, field) => {
    setTempData({ ...tempData, [field]: e.target.value });
  };



// Make sure 'assignees' is always an array
const handleSave = async (field) => {
    try { 
      const updatedFieldData = { [field]: tempData[field] };
  
      console.log('Updated data being sent:', updatedFieldData);
  
      // Set temporary data to formData for immediate reflection in the UI
      setFormData((prevFormData) => ({ ...prevFormData, [field]: tempData[field] }));
      setIsEditing((prevState) => ({ ...prevState, [field]: false }));
  
      // Send the updated field data to the backend API
      const response = await axios.post(
        `${baseurl}updateProjectManagement/${id}`,  
        updatedFieldData  
      );
  
      console.log("response", response);
  
      if (response.data.message === 'Project updated successfully') {
        console.log('Project updated successfully');
        
        // Ensure assignees is always an array
        const updatedProject = response.data.updatedProject; // Assuming this is the updated project data returned
        updatedProject.assignees = Array.isArray(updatedProject.assignees) ? updatedProject.assignees : [];
  
        // Update formData with the complete project data from backend
        setFormData(updatedProject); // Update formData with the complete project data from backend
  
        toast.success('Project updated successfully!'); // Show success toast
      } else {
        console.error('Failed to update project');
        toast.error('Failed to update project.'); // Show error toast
      }
    } catch (err) {
      console.error('Error updating project:', err);
      toast.error('Error updating project.'); // Show error toast in case of exception
    }
  };
  
  
  



  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (error) return <div className="text-center py-5">{error}</div>;

  return (
    <>
      <div className="App bg-main" style={{ display: "flex" }}>
        <div style={{ flexGrow: 1, padding: "0px" }}>
          <AdminTopbar />
          <div className="px-4">
            <div className="container-fluid">
              <div className="mt-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  {formData?.file_name && (
                    <img
                      src={`${imageUrl}project/${formData.file_name}`}
                      alt="Project File"
                      className="img-fluid rounded me-2"
                      style={{ maxWidth: "100px", maxHeight: "100px" }}
                    />
                  )}
                  <h2 className="chart-title text-start">{formData?.labels}</h2>
                  <div className="d-flex align-items-center">
                    {formData?.assignees?.map((assignee) => (
                      <div className="avatar-wrapper" key={assignee.id}>
                        <img
                          src={
                            assignee.profile_image
                              ? `${imageUrl}assignee/${assignee.profile_image}`
                              : "https://via.placeholder.com/40"
                          }
                          alt={assignee.full_name}
                          className="avatar assignee-avatar"
                        />
                        <div className="tooltip">{assignee.full_name}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="row g-2">
                  <div className="col-md-8">
                    <div className=" card p-2">
                      <div className="row g-1">
                        <div className=" ">
                          <label htmlFor="description" className="form-label text-start w-100">
                            <strong>Project Description</strong>
                          </label>
                          <div className="card p-1 text-start">
                            {isEditing.description ? (
                              <textarea
                                className="form-control"
                                value={tempData.description}
                                onChange={(e) => handleChange(e, "description")}
                              />
                            ) : (
                              <div>{formData?.description}</div>
                            )}
                          </div>
                          {isEditing.description ? (
                            <div className=" text-start editsave" onClick={() => handleSave("description")}>Save</div>
                          ) : (
                            <div className=" text-start editsave" onClick={() => handleEditClick("description")}>Edit</div>
                          )}
                        </div>

                        <div className=" ">
  <label htmlFor="priority" className="form-label text-start w-100">
  <strong> Priority</strong>
  </label>
  <div className="card p-1 text-start">
    {isEditing.priority ? (
      <select
        className="form-control"
        value={tempData.priority}
        onChange={(e) => handleChange(e, "priority")}
      >
        <option value="Low">Low</option>
        <option value="Medium">Medium</option>
        <option value="High">High</option>
      </select>
    ) : (
      <div>{formData?.priority}</div>
    )}
  </div>
  {isEditing.priority ? (
    <div className="text-start editsave" onClick={() => handleSave("priority")}>Save</div>
  ) : (
    <div className="text-start editsave" onClick={() => handleEditClick("priority")}>Edit</div>
  )}
</div>


                        <div className="col-md-4">
                          <label htmlFor="plannedDate" className="form-label text-start w-100">
                          <strong> Planned Date:</strong> 
                          </label>
                          <div className="card p-1 text-start">
                            {isEditing.plannedDate ? (
                              <input
                                type="date"
                                className="form-control"
                                value={tempData.plannedDate}
                                onChange={(e) => handleChange(e, "plannedDate")}
                              />
                            ) : (
                              <div>{new Date(formData?.planned_date).toLocaleDateString()}</div>
                            )}
                          </div>
                          {isEditing.plannedDate ? (
                            <div className=" text-start editsave" onClick={() => handleSave("plannedDate")}>Save</div>
                          ) : (
                            <div className=" text-start editsave" onClick={() => handleEditClick("plannedDate")}>Edit</div>
                          )}
                        </div>

                        <div className="col-md-4">
                          <label htmlFor="completionDate" className="form-label text-start w-100">
                          <strong>Completion Date:</strong>  
                          </label>
                          <div className="card p-1 text-start">
                            {isEditing.completionDate ? (
                              <input
                                type="date"
                                className="form-control"
                                value={tempData.completionDate}
                                onChange={(e) => handleChange(e, "completionDate")}
                              />
                            ) : (
                              <div>{new Date(formData?.completion_date).toLocaleDateString()}</div>
                            )}
                          </div>
                          {isEditing.completionDate ? (
                            <div className=" text-start editsave" onClick={() => handleSave("completionDate")}>Save</div>
                          ) : (
                            <div className=" text-start editsave" onClick={() => handleEditClick("completionDate")}>Edit</div>
                          )}
                        </div>

                        <div className="col-md-4">
                          <label htmlFor="actualCompletionDate" className="form-label text-start w-100">
                          <strong>Actual Completion Date:</strong>  
                          </label>
                          <div className="card p-1 text-start">
                            {isEditing.actualCompletionDate ? (
                              <input
                                type="date"
                                className="form-control"
                                value={tempData.actualCompletionDate}
                                onChange={(e) => handleChange(e, "actualCompletionDate")}
                              />
                            ) : (
                              <div>{new Date(formData?.actual_completion_date).toLocaleDateString()}</div>
                            )}
                          </div>
                          {isEditing.actualCompletionDate ? (
                            <div className=" text-start editsave" onClick={() => handleSave("actualCompletionDate")}>Save</div>
                          ) : (
                            <div className="text-start editsave"  onClick={() => handleEditClick("actualCompletionDate")}>Edit</div>
                          )}
                        </div>

                        <div className="col-md-12 mt-3 mb-5">
                          <div className="card">
                            <AddTask project_id={id} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card">
                      <AddFiles project_id={id} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default ProjectDetails;
